import baseInitialize from './base';
import FaqAccordion from 'components/faq/FaqAccordion';
import FaqDialog from 'components/faqDialog';
import EventTypes from 'components/EventTypes';
import 'components/recentlyviewedproducts/RecentlyViewedProducts';
import usabillaFeedback from '../components/vendor/usabilla-feedback';

baseInitialize();

FaqAccordion.initialize('.row--faqFirstSection .js-faqSection');
FaqDialog.initialize('.row--faqList .js-faqSection');

if (AppSettings.usabillaOnFAQPageEnabled) {
  usabillaFeedback();
}

document.jq.trigger(EventTypes.RECENTLY_VIEWED_PRODUCTS_RENDER_REQUEST);
